<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:37
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-12-02 18:04:22
 * @FilePath: \qctsw-vue\packages\app\src\components\Basic\TimeLineCardMessage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { timeFormat } from '@qctsw/utils'
import { USER_TYPE_CODE } from '@/shared/constants'

const props = withDefaults(defineProps<{
  tip?: string
  title?: string
  content?: string
  subTitle?: string
  time?: string
  supplement?: {
    replyContent: string
    userTypeCode: keyof typeof USER_TYPE_CODE
    createTime: string
  }[]
}>(), {
  tip: '',
  title: '',
  content: '',
  subTitle: '',
  time: '',
  supplement: () => [],
})
</script>

<template>
  <div>
    <div v-if="props.tip" class="mb-2 text-slate-5 text-3.25">
      {{ props.tip }}
    </div>
    <div class="border-1 border-slate-2 rounded p-sm bg-slate-1">
      <div class="font-bold" :class="props.tip === '投诉人打分' ? 'color-primary text-5' : ''">
        {{ props.title }}
      </div>
      <div v-if="props.subTitle" class="font-bold leading-1.5em mt-2">
        {{ props.subTitle }}
      </div>
      <div class="leading-1.5em mt-2" :class="props.tip === '投诉人打分' ? 'color-primary text-5' : ''" v-html="props.content" />
      <slot name="supplement">
        <template v-if="supplement && supplement.length">
          <div v-for="(v, i) in supplement" :key="i" class="public-border-top mt-16 pt-16 ">
            <div class=" mb-12">
              <span class="fwb f0">{{ USER_TYPE_CODE[v.userTypeCode] }}回复</span>
              <span class="text-slate-4 ml-12 fs-13">{{ timeFormat(v.createTime, 'YYYY-MM-DD HH:mm') }}</span>
            </div>
            <span class="flex-grow min-w-0 break-all">{{ v.replyContent }}</span>
          </div>
        </template>
      </slot>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
